<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_operator.add_operator')">
    <template #content>
      <v-container class="add-operator">
        <v-form v-model="isFormValid"
                ref="addOperatorForm">
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('register.email')"
                            v-model="operator.email"
                            clearable
                            :rules="emailRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-radio-group :label="$t('admin_operator.user_type')"
                             v-model="operator.type"
                             :rules="requiredRules">
                <v-radio :label="$t('account_type.operator')"
                         :value="100"></v-radio>
                <v-radio :label="$t('account_type.admin')"
                         :value="369"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <b-form-group :label="$t('admin_operator.permissions')"
                        v-if="operator.type === 100">
            <OperatorPermissionSelector v-model="permissions"></OperatorPermissionSelector>
          </b-form-group>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('register.password')"
                            v-model="password"
                            :rules="passwordRules"
                            type="password"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('register.confirm_password')"
                            v-model="confirmPassword"
                            :rules="confirmPasswordRules"
                            type="password"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.addOperatorForm.validate() && save()">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";
import OperatorPermissionSelector from "@/components/operator/OperatorPermissionSelector";

export default {
  name: 'AddOperatorModal',
  components: {OperatorPermissionSelector, BGModal},
  props: {
    shown: Boolean,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          operator.value = {};
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    // Form
    const isFormValid = ref(false);

    const operator = ref({});

    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);
    const emailRules = ref([
      value => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || root.$t('register.invalid_email'),
    ]);

    const password = ref(null);
    const passwordRules = ref([
      value => (!!value && value.length >= 8) || root.$t('register.password_contain_eight_characters'),
      value => (!!value && !!value.match(/[A-Za-z]/g)) || root.$t('register.password_contain_letters'),
      value => (!!value && !!value.match(/[0-9]/g)) || root.$t('register.password_contain_numbers'),
      value => (!!value && !!value.match(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g) && !value.match(/[ ]/g)) || root.$t('register.password_contain_special_characters'),
    ]);
    const confirmPassword = ref(null);
    const confirmPasswordRules = ref([
      value => (!!value && value === password.value) || root.$t('register.password_match'),
    ]);

    const permissions = ref([]);

    const save = function () {
      root.$callAPI('hkiarace/admin/operator/create/', {
        ...operator.value,
        permissions: permissions.value,
        password: password.value,
      }, () => {
        emit('finish');
      });
    }

    return {
      dialogShown,
      cancel,

      isFormValid,
      operator,

      requiredRules,
      emailRules,

      password,
      passwordRules,
      confirmPassword,
      confirmPasswordRules,

      permissions,

      save,
    }
  }
}
</script>
